import { TableType } from './table-type';

export class TableTypeVersion {
    id: number;
    tableType: TableType;
    version: string;
}